import { useEffect } from "react";

const adsenseScriptId = "google-adsense-script";

/**
 * Load the Google AdSense script on the client after hydration.
 *
 * @remarks
 * Rendering the async AdSense `<script>` in the SSR `<head>` let it run
 * before React hydrated the document; it injects nodes into `<head>`/`<body>`,
 * so React 18 failed hydration at the document root and re-rendered the whole
 * page on the client on every page load of tenants with AdSense enabled.
 *
 * @example
 * useGoogleAdsenseScript(settings?.integrations?.googleAdsense);
 */
export function useGoogleAdsenseScript(clientCode?: string | null) {
  useEffect(() => {
    if (!clientCode || document.getElementById(adsenseScriptId)) return;

    const script = document.createElement("script");
    script.id = adsenseScriptId;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(clientCode)}`;
    document.head.appendChild(script);
  }, [clientCode]);
}
